import { useOutletContext, Link } from "react-router-dom";

export default function ProfilePage() {
  const { me } = useOutletContext();
  return (
    <div>
      <div className="section-eyebrow">Profile</div>
      <h1 className="mt-1 font-display text-3xl leading-tight" style={{ color: "var(--primary)" }}>Your account</h1>
      <div className="mt-6 card-soft p-6 space-y-3">
        <Row k="Name" v={me.user.name} />
        <Row k="Email" v={me.user.email} />
        <Row k="Role" v={me.user.role} />
        {me.client && (
          <>
            <Row k="Phone" v={me.client.phone} />
            <Row k="City" v={me.client.city || "—"} />
            <Row k="Plan" v={me.client.plan_type ? me.client.plan_type.toUpperCase() : "—"} />
          </>
        )}
      </div>
      {me.user.role === "owner" && (
        <Link to="/admin" className="btn-primary mt-6 w-full justify-center">Open full CRM</Link>
      )}
    </div>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex justify-between py-1.5" style={{ borderBottom: "1px dashed var(--border-subtle)" }}>
      <span className="text-xs uppercase tracking-widest font-bold" style={{ color: "var(--text-secondary)" }}>{k}</span>
      <span className="font-bold" style={{ color: "var(--primary)" }}>{v}</span>
    </div>
  );
}
